import { useCurrentInstance } from './useCurrentInstance'

export const useImagePreview = () => {
  const { globalProperties } = useCurrentInstance()
  const preview = (url: string | string[], initialViewIndex?: number) => {
    globalProperties.$viewerApi({
      images: typeof url === 'string' ? [url] : url,
      options: {
        initialViewIndex
      }
    })
  }
  return {
    preview
  }
}
